export default __webpack_public_path__ + "static/media/confirm.5cdea4ba.png";